import type { ButtonHTMLAttributes, ReactNode } from 'react';

type ButtonVariant = 'primary' | 'ghost' | 'cta' | 'cta-ghost' | 'primary-state' | 'ghost-state' | 'green';

interface ButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'className'> {
  variant?: ButtonVariant;
  className?: string;
  children: ReactNode;
}

const VARIANT_CLASS: Record<ButtonVariant, string> = {
  primary: 'btn-primary',
  ghost: 'btn-ghost',
  cta: 'cta-primary',
  'cta-ghost': 'cta-ghost',
  'primary-state': 'btn-primary-state',
  'ghost-state': 'btn-ghost-state',
  green: 'btn-primary-state green',
};

export function Button({ variant = 'primary', className, children, type, ...rest }: ButtonProps) {
  const cls = VARIANT_CLASS[variant];
  return (
    <button type={type ?? 'button'} className={`${cls}${className ? ` ${className}` : ''}`} {...rest}>
      {children}
    </button>
  );
}
